import { ServicePlanFeature, ServicePlanFeatureData, ServicePlanFeatureHelper } from "@app/project/model/service-plan-feature";
import { DbHelper } from "@app/shared/model/db-object.model";
import { ClassImporterExporter } from "@app/shared/resources/class-importer-exporter.service";
import { ServicePlanTiers } from "./service-plan";

interface DisplayJson {
    color: string;
    statusColor?: string;
}

export interface ClareServicePlanData {
    id?: number;
    name?: ServicePlanTiers;
    description?: string;
    effective_start_date?: string;
    effective_end_date?: string;
    length_months?: number;
    base_price?: number;
    early_termination_fee?: number;
    early_termination_enabled?: boolean;
    early_termination_fee_rate?: number;
    dealer_fee_waive?: boolean;
    display_json?: DisplayJson;
    active?: boolean;
    service_plan_count?: number;
    features: ServicePlanFeatureData[];
}

export interface ClareServicePlan {
    id: number;

    name: string;

    basePrice: number | null;
    dealerFeeWaived: boolean | null;
    description: string | null;
    earlyTerminationEnabled: boolean | null;
    earlyTerminationFee: number | null;
    earlyTerminationFeeRate: number | null;
    endDate: string | null;
    startDate: string | null;
    lengthMonths: number | null;

    displayJson: DisplayJson;
    features: ServicePlanFeature[];
}

export class ClareServicePlanHelper extends DbHelper<ClareServicePlan, ClareServicePlanData> {
    static readonly importMap = [
        { i: "id", o: "id" },
        { i: "name", o: "name" },
        { i: "base_price", o: "basePrice" },
        { i: "dealer_fee_waive", o: "dealerFeeWaived" },
        { i: "description", o: "description" },
        { i: "early_termination_enabled", o: "earlyTerminationEnabled" },
        { i: "early_termination_fee", o: "earlyTerminationFee" },
        { i: "early_termination_fee_rate", o: "earlyTerminationFeeRate" },
        { i: "effective_end_date", o: "endDate" },
        { i: "effective_start_date", o: "startDate" },
        { i: "length_months", o: "lengthMonths" },
        { i: "display_json", o: "displayJson" },
    ] as const;

    readonly importMap = ClareServicePlanHelper.importMap;

    static fromDbObject(data: ClareServicePlanData): ClareServicePlan {
        return {
            ...ClassImporterExporter.importObject(data, ClareServicePlanHelper.importMap),
            features: data.features.map(f => ServicePlanFeatureHelper.fromDbObject(f)),
        };
    }

    fromDbObject(dbObject: ClareServicePlanData): ClareServicePlan {
        return ClareServicePlanHelper.fromDbObject(dbObject);
    }
}
